import Vue from 'vue'
import App from './App.vue'
import router from './router'
import echarts from 'echarts'
import 'echarts-liquidfill'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import TableList from './components/table' //引入全局tableList组件
import scroll from 'vue-seamless-scroll'


Vue.prototype.$echarts = echarts
Vue.use(ElementUI,scroll);
Vue.component('TableList', TableList) //注册全局组件  页面共用的表格 供全局使用

Vue.config.productionTip = false
var vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default vue
